module.exports = __webpack_public_path__ + "static/media/brandname.c2e4b7ed.svg";